import { TaskType } from '@/services/uploaderService';
import { Tooltip } from '@/ui/tooltip';
import DownloadButton from '../DownloadButton';
import { useDownloadNoWatermarkButton } from './useDownloadNoWatermarkButton';

export function DownloadNoWatermarkButton({
  isAIToolbarCTAActive,
}: {
  isAIToolbarCTAActive: boolean;
}) {
  const { isTooltipVisible, tooltipText, onTooltipDisappear, mediaType } =
    useDownloadNoWatermarkButton();
  return (
    <Tooltip
      visible={isTooltipVisible}
      content={tooltipText}
      position="bottom"
      duration={10000}
      afterDisappear={onTooltipDisappear}
    >
      <DownloadButton
        isAIToolbarCTAActive={isAIToolbarCTAActive}
        mediaType={mediaType as TaskType}
      />
    </Tooltip>
  );
}
